<template>
  <div>
    <SiteConclusion @successfully="successfully" :items="conclusionSite" v-if="submitStatus"/>
    <template v-else>
      <Breadcrumbs :items="itemsBreadcrumbs" class="ml-n6"/>
      <Heading :title="t$.title" header headerColor="gray scale200"/>
      <form @submit.stop.prevent="handleCreateSite">
        <Row>
          <Col cols="12" md="6">
            <SelectionField v-model="type" type="radio" cols="12" :items="domainOptions" wrapper-tag="Card"
                            activation-position="hidden" custom-label :wrapper-props="{outlined: true, hover: true}">
              <template #label="{item}">
                <div class="d-flex justify-center justify-space-between align-start" @click="trackSelectionFieldClick(item.label)">
                  <Picture class="mr-3" maxHeight="90" :src="item.image"/>
                  <div class="flex-grow-1">
                    <span class="text-paragraph-1 mb-3 font-weight-bold" v-text="item.label"/>
                    <span class="d-block text-paragraph-2" v-text="item.description"/>
                  </div>
                </div>
              </template>
            </SelectionField>
          </Col>
        </Row>
        <Row>
          <Col cols="12" v-if="createDomain">
            <BubbleHint :group-areas="bubbleAreas">
              <template #group.1>
                <TextField :label="t$.fields.domainField.label" :ga="inputsEvent('dominioDoSite')" :placeholder="t$.fields.domainField.placeholder"
                           required :errorMessages="domainErrors" v-model.trim="site.domain"
                           v-on="bindEvents('domain')"/>
              </template>
            </BubbleHint>
          </Col>
          <Col cols="12" md="6">
            <Fieldset :label="loginInformation"/>
            <Row>
              <Col cols="12">
                <TextField :label="t$.fields.title.label" :ga="inputsEvent('tituloDoSite')" :hint="t$.fields.title.hint" :errorMessages="titleErrors"
                           required v-on="bindEvents('title')" v-model.trim="site.title" :maxLength="160"/>
              </Col>
              <Col cols="12">
                <TextField :label="t$.fields.email.label" :ga="inputsEvent('eMail')" :hint="t$.fields.email.hint" :errorMessages="emailErrors"
                           required v-on="bindEvents('email')" v-model.trim="site.email"/>
              </Col>
              <Col cols="12">
                <TextField :label="t$.fields.user.label" :ga="inputsEvent('usuarioDoWordpress')" :hint="t$.fields.user.hint" :errorMessages="userErrors"
                           :maxLength="18" spacePrevent v-model="site.user" required v-on="bindEvents('user')"/>
              </Col>
              <!-- <Col cols="12">
                <PasswordField :label="t$.fields.password.label" :hint="t$.fields.password.hint" displayPassword
                               minLength="14" maxLength="30" required validation :errorMessages="passwordErrors"
                               v-on="bindEvents('password')" v-model.trim="site.password"/>
              </Col> -->
              <Col cols="12">
                <PasswordField required :label="t$.fields.password.label" :ga="inputsEvent('adicionarSenhaDoWordpress')" :hint="t$.fields.password.hint" placeholder="Digite aqui" maxLength="30" minLength="8" v-model="passwordToConfirm" validation @blur="$v.passwordToConfirm.$touch()" :errorMessages="passwordToConfirmErrors"/>
              </Col>

              <Col cols="12">
                <PasswordField required label="Confirme sua senha" :ga="inputsEvent('confirmarSenhaDoWordpress')" placeholder="Digite aqui" maxLength="30" minLength="8" v-model="passwordConfirmation" :errorMessages="passwordConfirmationErrors" @blur="$v.passwordConfirmation.$touch()"/>
              </Col>
            </Row>
          </Col>
        </Row>
        <Button class="mt-12" v-bind="buttonProps" :label="createNewSite" :disabled="migrationInProgress" color="primary" :ga="gEvents.criarNovoSiteEnviarFormulario" type="submit" />
      </form>
    </template>
  </div>
</template>

<script>
import { useFindPlan } from '@/views/site/functions/useFindPlan'
import {
  Breadcrumbs,
  BubbleHint,
  Button,
  Col,
  Fieldset,
  Heading,
  PasswordField,
  Picture,
  Row,
  SelectionField,
  TextField,
  useLocale,
  useValidation,
  passwordErrorMessages,
  confirmPasswordErrorMessages
} from '@locaweb/design-system-vue'
import createWebsite from '@/assets/illustration/create_website.svg'
import transferWebsite from '@/assets/illustration/transfer_website.svg'
import DomainBubble from '@/views/site/form/components/DomainBubble'
import { computed, ref, onMounted } from 'vue'
import Site from '@/views/site/api/model/Site'
import SiteConclusion from '@/views/site/list/components/SiteConclusion'
import { checkDomain, postWebsite, websiteTransfer, checkMigration } from '@/views/site/api/site.api'
import { gEventsTrigger } from '@/functions/gEventsTrigger'

export default {
  name: 'SiteForm',
  props: {
    id: String
  },
  components: {
    Breadcrumbs,
    SiteConclusion,
    Heading,
    SelectionField,
    Row,
    Col,
    Picture,
    BubbleHint,
    TextField,
    Fieldset,
    PasswordField,
    Button
  },
  data () {
    return {
      site: {},
      messageErrorDomain: '',
      domainStatusCheck: false,
      passwordToConfirm: '',
      passwordConfirmation: '',
      submitStatus: false
    }
  },
  methods: {
    trackSelectionFieldClick (label) {
      const gEvents = this.$gEvents('criarNovoSite')
      if (label === 'Quero criar um novo site') {
        this.$dga.event(gEvents.queroCriarUmSite)
      } else {
        this.$dga.event(gEvents.queroTransferirUmSite)
      }
    },
    inputsEvent (inputName) {
      return gEventsTrigger(this.gEvents, inputName)
    },
    handleCreateSite () {
      if (this.site.domain) {
        this.domainCheck(this.site, this.id)
      } else {
        this.site.password = this.passwordConfirmation
        websiteTransfer(this.site, this.id)
        this.submitStatus = true
      }
    },
    async domainCheck (site, id) {
      this.messageErrorDomain = ''
      this.statusError = ''
      try {
        const data = await checkDomain(site.domain, id)
        this.domainStatusCheck = data.status
        this.site.password = this.passwordConfirmation
        postWebsite(site, id)
        this.submitStatus = true
      } catch ({ response: { status, data } }) {
        if (status === 422) {
          this.messageErrorDomain = data.message
          this.domainStatusCheck = status
          this.domainErrors = data.message
          this.submitStatus = false
        } else {
          console.error('Algo deu errado. Por favor, tente novamente.')
        }
      }
    },
    successfully () {
      this.$router.push(`/${this.id}`)
    }
  },
  setup (props) {
    const type = ref('create')
    const v$ = useValidation()
    // const site = ref(Site.model)
    useFindPlan(props.id)
    const t$ = useLocale('sites.form')
    const domainOptions = Object.keys(t$.fields.domain).map(key => ({
      value: key,
      text: key,
      ...t$.fields.domain[key],
      image: key === 'create' ? createWebsite : transferWebsite
    }))
    const bubbleAreas = [
      {
        label: 'Domínio',
        hintComponent: DomainBubble
      }
    ]
    const createDomain = computed(_ => type.value === 'create')
    const loginInformation = t$.adminSites
    const createNewSite = t$.createNewSite

    function bindEvents (field) {
      return {
        input: () => v$.value.site[field].$touch(),
        blur: () => v$.value.site[field].$touch()
      }
    }

    const migrationInProgress = ref(false)

    const checkMigrationStatus = async () => {
      try {
        const result = await checkMigration(props.id)
        migrationInProgress.value = !!result
      } catch (error) {
        console.error('Error checking migration:', error)
      }
    }

    onMounted(checkMigrationStatus)

    return {
      t$,
      domainOptions,
      bubbleAreas,
      type,
      createDomain,
      loginInformation,
      createNewSite,
      migrationInProgress,
      bindEvents
    }
  },
  validations: Site.validations,
  computed: {
    ...Site.validationsErrors,
    ...passwordErrorMessages('password'),
    ...passwordErrorMessages('passwordToConfirm'),
    ...confirmPasswordErrorMessages('passwordConfirmation'),
    itemsBreadcrumbs () {
      const title = JSON.parse(localStorage.getItem('headerProps'))

      const items = [
        { text: 'Listagem de Planos', to: '/', disabled: false, exact: true },
        { text: title, to: `/${this.id}`, disabled: false, exact: true },
        { text: 'Criar Novo Site', disabled: false, exact: false }
      ]
      return items
    },
    statusDomainCheck () {
      let status = ''
      if (this.site.domain === '') {
        status = false
      } else {
        status = this.domainStatusCheck
      }
      return status
    },
    buttonProps () {
      let status = true
      if (this.createDomain) {
        if (
          this.site.domain &&
          this.domainErrors <= 0 &&
          this.site.title &&
          this.titleErrors <= 0 &&
          this.site.email &&
          this.emailErrors <= 0 &&
          this.site.user &&
          this.userErrors <= 0 &&
          this.passwordConfirmation &&
          this.passwordConfirmation === this.passwordToConfirm
        ) {
          status = false
        }
      } else {
        if (
          this.site.title &&
          this.titleErrors <= 0 &&
          this.site.email &&
          this.emailErrors <= 0 &&
          this.site.user &&
          this.userErrors <= 0 &&
          this.passwordConfirmation &&
          this.passwordConfirmation === this.passwordToConfirm
        ) {
          status = false
        }
      }
      const props = {
        disabled: status
      }
      return props
    },
    conclusionSite () {
      const data = this.t$.conclusion
      return data
    },
    gEvents () {
      return this.$gEvents('criarNovoSite')
    }
  }
}
</script>
